import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addNotification } from 'modules/notifications/redux';
import { NotificationTypes } from 'modules/notifications';
import { InclusionZonesApi } from '../api';
import { InclusionZoneActions } from '../redux';

export const useDeleteAllInclusionZones = (
  closeModal: () => void,
): {
  loading: boolean;
  hasError: boolean;
  handleDeleteAll: () => Promise<void>;
} => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleDeleteAll = useCallback(async () => {
    setLoading(true);
    setHasError(false);
    try {
      await InclusionZonesApi.deleteAllInclusionZones();
      dispatch(InclusionZoneActions.deleteAllInclusionZones());
      dispatch(
        addNotification({
          type: NotificationTypes.Success,
          message: `All inclusion zones have been deleted successfully.`,
        }),
      );
      closeModal();
    } catch (err) {
      setHasError(true);
      dispatch(
        addNotification({
          type: NotificationTypes.Error,
          message: `Error while deleting all inclusion zones.`,
        }),
      );
    } finally {
      setLoading(false);
    }
  }, [dispatch, closeModal]);

  return {
    loading,
    hasError,
    handleDeleteAll,
  };
};
